import querystring from "query-string";
export * from "./throttle";
export * from "./lang";
export * from "./cookie";
export * from "./date";

export const isBrowser =
  typeof window !== "undefined" && typeof window.navigator !== "undefined";

// 读取埋点，需要修改为从 sessionStorage 里面读
// 注意 window 对象

// 对应的，sessionStorage 在 app 落地的时候被写入

let r = typeof window !== "undefined";
let session = r && window.sessionStorage;

// SEO SEM 来源区分标识
export const isSem = () =>
  r &&
  (window.location.hostname.indexOf("authing.co") !== -1 ||
    window.location.hostname.indexOf("authingyun.com") !== -1);

// 内容营销渠道标识
export const promotingAds = () => r && session.getItem("hmsr");

// 数字营销渠道标识
export const digitalMarketingChannels = () => r && session.getItem("dmc");

// 特殊营销渠道标识
export const specialMarketingChannels = () => r && session.getItem("smc");

export * from "./tryNow";
